import type { AppStore } from "@/store/AppStore";
import {
  executeAiToolkitTool as executeSharedAiToolkitTool,
  serializeAiToolkitError,
  type AiToolkitSerializedError,
  type AiToolkitToolOutput,
} from "@mem-client/ai-toolkit";
import { aiToolkitToolsByName } from "@/modules/ai-toolkit/tools";

export const getAiToolkitErrorMessage = ({ error }: { error: unknown }): string => {
  return serializeAiToolkitError({ error }).message;
};

export const getAiToolkitSerializedError = ({
  error,
}: {
  error: unknown;
}): AiToolkitSerializedError => serializeAiToolkitError({ error });

export const executeAiToolkitTool = async ({
  store,
  toolName,
  input,
}: {
  store: AppStore;
  toolName: string;
  input: unknown;
}): Promise<AiToolkitToolOutput> => {
  return executeSharedAiToolkitTool({
    toolsByName: aiToolkitToolsByName,
    executeArgs: { store },
    toolName,
    input,
  });
};
